var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -47.775,
    y: -55.3,
    width: 863.55,
    height: 125.075
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(23.89px)",
      clipPath: "url(#bgblur_0_6405_31038_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6405_31038)",
    "data-figma-bg-blur-radius": 47.775
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768 1H0V9.47619H345.639C348.625 9.47619 351.363 11.1399 352.739 13.7909L354.761 17.6853C356.137 20.3362 358.875 22 361.861 22H406.139C409.125 22 411.863 20.3362 413.239 17.6853L415.261 13.7909C416.637 11.1399 419.375 9.47619 422.361 9.47619H768V1Z",
    fill: "#0057FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2V8.47656H345.639C348.999 8.47656 352.079 10.3478 353.627 13.3301L355.648 17.2246C356.852 19.5441 359.248 21 361.861 21H406.139C408.752 21 411.148 19.5441 412.352 17.2246L414.373 13.3301C415.921 10.3478 419.001 8.47656 422.361 8.47656H767V2H1Z",
    stroke: "url(#paint0_linear_6405_31038)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 325.225,
    y: -35.775,
    width: 117.55,
    height: 98.55
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(23.89px)",
      clipPath: "url(#bgblur_1_6405_31038_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6405_31038)",
    "data-figma-bg-blur-radius": 47.775
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 3,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 395 12)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6405_31038",
    x: -47.775,
    y: -55.3,
    width: 863.55,
    height: 125.075,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6405_31038"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6405_31038",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_6405_31038_clip_path",
    transform: "translate(47.775 55.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768 1H0V9.47619H345.639C348.625 9.47619 351.363 11.1399 352.739 13.7909L354.761 17.6853C356.137 20.3362 358.875 22 361.861 22H406.139C409.125 22 411.863 20.3362 413.239 17.6853L415.261 13.7909C416.637 11.1399 419.375 9.47619 422.361 9.47619H768V1Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6405_31038",
    x: 325.225,
    y: -35.775,
    width: 117.55,
    height: 98.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6405_31038"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6405_31038",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_6405_31038_clip_path",
    transform: "translate(-325.225 35.775)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 3,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 395 12)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6405_31038",
    x1: 401.067,
    y1: 21.4737,
    x2: 401.067,
    y2: 14.5263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363FBC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartDown);
export default __webpack_public_path__ + "static/media/cart-down.fdd493fdd452e06e9002dd041b960536.svg";
export { ForwardRef as ReactComponent };